import { jsx } from 'react/jsx-runtime';
import cx from 'clsx';
import { s as styleInject } from './style-inject.es-Bff-fD1R.js';

const variantConfigMap = {
    mobile: {
        width: 97,
        height: 14,
    },
    desktop: {
        width: 158,
        height: 23,
    },
};

const SGCM_LOGO_URL = 'https://media.i-sgcm.com/public/components/header/sgcm-logo.svg';
const SGCM_LOGO_VARIANT_MOBILE = 'mobile';
const SGCM_LOGO_VARIANT_DESKTOP = 'desktop';

var css_248z = ".SGCM_UIKIT_NEXT_SgcmLogo_linkRoot_x7nln_1 {\n  display: inline-block;\n  line-height: 0;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLHFCQUFxQjtFQUNyQixjQUFjO0FBQ2hCIiwiZmlsZSI6InN0eWxlcy5tb2R1bGUuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5saW5rUm9vdCB7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgbGluZS1oZWlnaHQ6IDA7XG59Il19 */";
var styles = {"linkRoot":"SGCM_UIKIT_NEXT_SgcmLogo_linkRoot_x7nln_1"};
styleInject(css_248z);

const SgcmLogo = ({ variant, className, baseUrlMap }) => {
    const { width, height } = variantConfigMap[variant];
    return (jsx("a", { className: cx(styles.linkRoot, className), href: baseUrlMap[variant], rel: "noreferrer noopener", children: jsx("img", { alt: "Sgcm logo", className: className, height: height, src: SGCM_LOGO_URL, width: width }) }));
};

export { SgcmLogo as S, SGCM_LOGO_VARIANT_DESKTOP as a, SGCM_LOGO_VARIANT_MOBILE as b };
//# sourceMappingURL=component-D5qJ4zZ9.js.map
